export enum ResponseCode {
  OK = 200,
  INCORRECT_DOB = 101,
  CREATED = 201,
  ACCEPTED = 202,
  NO_CONTENT = 204,
  MOVED_PERMANENTLY = 301,
  FOUND = 302,
  SEE_OTHER = 303,
  NOT_MODIFIED = 304,
  TEMPORARY_REDIRECT = 307,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,
  UNPROCESSABLE_ENTITY = 422,
  INTERNAL_SERVER_ERROR = 500,
  NOT_IMPLEMENTED = 501,
  BAD_GATEWAY = 502,
  SERVICE_UNAVAILABLE = 503,
  HTTP_ERROR = 600,
}

export enum AuthError {
  SessionExpired = '301',
  AuthError = '101',
  AttemptsExhausted = '201',
}

export enum Method {
  GET = 'get',
  POST = 'post',
  PUT = 'put',
  PATCH = 'patch',
  DELETE = 'delete',
}

export const RETRY_CONFIG = {
  // should be moved to API config
  [Method.GET]: 3,
  [Method.POST]: 1,
  [Method.PUT]: 1,
  [Method.PATCH]: 1,
  [Method.DELETE]: 1,
};

export enum RequestType {
  INTERNAL,
  EXTERNAL,
}

export const HEADERS = {
  device: 'x-imprint-device-id',
  signature: 'x-imprint-signature',
  language: 'Accept-Language',
  token: 'x-imprint-access-token',
  platform: 'x-imprint-platform',
  clientSecret: 'x-imprint-client-secret',
  sessionId: 'x-imprint-session-id',
  productUUID: 'x-imprint-product-uuid',
  telemetryID: 'x-imprint-telemetry-id',
};

export const PLATFORM = 'WEB';
